import { render, staticRenderFns } from "./SurveySection.vue?vue&type=template&id=2b1d31f4&scoped=true"
import script from "./SurveySection.vue?vue&type=script&lang=js"
export * from "./SurveySection.vue?vue&type=script&lang=js"
import style0 from "./SurveySection.vue?vue&type=style&index=0&id=2b1d31f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d31f4",
  null
  
)

export default component.exports